/**
 * Centralizované ikonky pre konzistentnú používateľskú skúsenosť
 * Použitie: import { categoryIcons, benefitIcons } from "@/lib/icons";
 */

import { Shirt, Grid3X3, Star, Zap, MapPin, ClipboardList, type LucideIcon } from "lucide-react";

// Ikonky pre kategórie/taby produktov
export const categoryIcons: Record<string, LucideIcon> = {
  typ: Shirt,           // Typ produktu - tričko
  kolekcie: Grid3X3,    // Kolekcie - mriežka/grid
  specialne: Star,      // Špeciálne - hviezda
};

// Ikonky pre výhody registrácie
export const benefitIcons: Record<string, LucideIcon> = {
  rychlejsiNakup: Zap,           // Rýchlejší nákup - blesk
  viacAdries: MapPin,            // Viac adries doručenia - pin
  historiaObjednavok: ClipboardList, // História objednávok - zoznam
};
